import { z } from 'zod';
import type { AISchemaField, UISchemaField } from '../types/index';

export const testimonialsAISchema: AISchemaField[] = [
  { name: 'eyebrow', type: 'string', required: false, max: 30 },
  { name: 'headline', type: 'string', required: false, max: 80 },
  {
    name: 'testimonials',
    type: 'array<object>',
    required: true,
    fields: [
      { name: 'quote', type: 'string', required: true, max: 280 },
      { name: 'name', type: 'string', required: true, max: 40 },
      { name: 'role', type: 'string', required: false, max: 60 },
      { name: 'company', type: 'string', required: false, max: 40 },
      { name: 'avatar', type: 'image_url', required: false },
      { name: 'rating', type: 'string', required: false, max: 4 },
    ],
  },
];

export const testimonialsUISchema: UISchemaField[] = [
  { name: 'eyebrow', type: 'text', label: 'Eyebrow', max: 30 },
  { name: 'headline', type: 'text', label: 'Headline', max: 80 },
  { name: 'testimonials', type: 'testimonial_list', label: 'Testimonials', required: true },
];

export const testimonialsZodSchema = z.object({
  eyebrow: z.string().max(30).optional().nullable(),
  headline: z.string().max(80).optional().nullable(),
  testimonials: z
    .array(
      z.object({
        quote: z.string().max(280),
        name: z.string().max(40),
        role: z.string().max(60).optional().nullable(),
        company: z.string().max(40).optional().nullable(),
        avatar: z.string().optional().nullable(),
        rating: z.string().max(4).optional().nullable(),
      }),
    )
    .min(1)
    .max(12),
});

export type TestimonialsContent = z.infer<typeof testimonialsZodSchema>;

export const testimonialsSample: TestimonialsContent = {
  eyebrow: 'What teams say',
  headline: 'Real studios. Real work.',
  testimonials: [
    {
      quote: 'Atlas Pro shaved hours off our daily review cycle. Color is genuinely accurate out of the box.',
      name: 'Sara Tan',
      role: 'Color supervisor',
      company: 'Lumen Studios',
      avatar: null,
      rating: '5',
    },
    {
      quote: 'I switched our entire post pipeline to Atlas Mini and gained desk space without losing a single FPS.',
      name: 'Mateo Reyes',
      role: 'Editor',
      company: 'Bluepoint Films',
      avatar: null,
      rating: '5',
    },
    {
      quote: 'The Air feels like a desktop you can fold into a bag. Battery actually delivers what they claim.',
      name: 'Nadia Ferreira',
      role: 'Photographer',
      company: 'Daylight Co.',
      avatar: null,
      rating: '5',
    },
  ],
};
